module.exports = __webpack_public_path__ + "img/77309.01ff9e20.svg";